import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { Heading, Text } from '../common/Typography';
import LandingHeroCollage from './mockups/LandingHeroCollage';

const LandingHero = () => (
  <section className="px-4 py-12 sm:px-6 sm:py-16 lg:px-10 lg:py-20" aria-labelledby="landing-hero-heading">
    <div className="mx-auto grid max-w-app-shell items-center gap-10 lg:grid-cols-2 lg:gap-14">
      <div>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
          For players, by players
        </p>
        <Heading id="landing-hero-heading" level={1} className="text-4xl sm:text-5xl lg:text-[3.15rem] tracking-tight">
          Better sessions.{' '}
          <span className="text-success-dark">More badminton.</span>
        </Heading>
        <Text className="mt-5 max-w-xl text-base sm:text-lg text-text-secondary">
          Fairer games, shorter waits, more variety. After the night, players can
          look back at their history and head-to-heads.
        </Text>
        <div className="mt-8">
          <Button as={Link} to="/signup" variant="primary" size="large" className="w-full !border-2 !border-secondary sm:w-auto">
            Create Account
          </Button>
        </div>
      </div>
      <LandingHeroCollage />
    </div>
  </section>
);

export default LandingHero;
